var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"myChart",attrs:{"height":"80"}})
}
var staticRenderFns = []

export { render, staticRenderFns }